import { render, staticRenderFns } from "./IrrFormComponent.vue?vue&type=template&id=8ac042c0"
import script from "./IrrFormComponent.vue?vue&type=script&lang=js"
export * from "./IrrFormComponent.vue?vue&type=script&lang=js"
import style0 from "./IrrFormComponent.vue?vue&type=style&index=0&id=8ac042c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports